import HTML from '../../html'
import sharedData from '../../shared-data'
import PropListView from '../Finder/property-lister/view'
import {imagesToSvg} from "../../utils"

export default class PropertyRouteMap {
    constructor(blockRoot) {
        this.root = blockRoot

        // Map will be rendered here:
        this.mapRoot = this.root.find('.prm__map-root')
        this.directionStepsRoot = this.root.find('.prm__direction-steps')
        this.directionStepsWrapper = this.root.find('.prm__direction-steps-wrapper')

        this.geocodeInput = this.root.find('.prm__controls__inputs .address')
        this.addressInput = this.root.find('.prm__controls .currentAddress')
        this.originInput = this.root.find('.prm__controls .originAddress')

        this.geocodeAid = this.root.find('.geocode-aid')
        this.googleDirectionsUrl = 'https://www.google.com/maps/dir/?api=1'

        // Action buttons:
        this.buttons = {
            currentLocation: this.root.find('.prm__controls__geolocation'),
            drivingTravelMode: this.root.find('.driving-travel-mode'),
            walkingTravelMode: this.root.find('.walking-travel-mode'),
            bicyclingTravelMode: this.root.find('.bicycling-travel-mode'),
            buildRoute: this.root.find('.prm__controls__submit'),
            buildDirections: this.root.find('.prm__controls__directions'),
            directionDetailsToggler: this.root.find('.prm__direction-steps-toggler'),
        }

        this.projektWPID = this.root.data('property-projekt-id')
        this.originPosition = {
            lat: this.root.data('property-latitude') || 0,
            lng: this.root.data('property-longitude') || 0,
        }
        // View layer for rendering projekt and objekt cards
        this.propListView = new PropListView(this)

        this.googleMap = false
        this.directionsResult = false
        this.directionsRenderer = false
        this.position = this.originPosition

        this.init()
    }

    /**
     * Requests google server to parse address. Asynchronous
     * @param {string} address
     * @param {function} callback
     */
    geocodeFromAddress(address, callback) {
        var request = {
            address: address,
            region: 'sv_SE',
        }
        this.geocoder.geocode(request, (result, status) => {
            if (typeof callback === 'function') {
                callback(result, status)
            }
        })
    }

    /**
     * Requests google server to parse location. Asynchronous
     * @param {latLng} location
     * @param {function} callback
     */
    geocodeFromLocation(location, callback) {
        var request = {
            location: location,
        }
        this.geocoder.geocode(request, (result, status) => {
            if (typeof callback === 'function') {
                callback(result, status)
            }
        })
    }

    /**
     * Get Origin position from current user's position, if available. Asynchronous
     * @param {function} callback
     * @returns {PropertyRouteMap}
     */
    positionFromGeolocation(callback) {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(position => {
                this.setPosition({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                })
                if (typeof callback === 'function') {
                    callback(position)
                }
            }, failure => {
                this.buttons.currentLocation.remove()
            })
        } else {
            this.buttons.currentLocation.remove()
        }
        return this
    }

    /**
     * Execute all geopositioning procedure from geopositioning request to route render
     */
    executeGeolocation() {
        this.positionFromGeolocation(position => {
            var geocoderRequest = {
                location: {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                },
            }
            this.geocoder.geocode(geocoderRequest, results => {
                if (results.length > 0) {
                    this.geocodeInput.val(results[0].formatted_address)
                }
            })
        })
    }

    /**
     *
     * @param {latLng} position
     * @returns {PropertyRouteMap}
     */
    setPosition(position = this.position) {
        this.position = position
        return this
    }

    /**
     * Set route travel mode
     * @param {string} slug Name of the google.maps.TravelMode constant
     * @returns {PropertyRouteMap}
     */
    setTravelMode(slug) {
        /BICYCLING|DRIVING|TRANSIT|WALKING/.test(slug)
        ? this.travelMode = google.maps.TravelMode[slug]
        : this.travelMode = google.maps.TravelMode.DRIVING
        return this
    }

    /**
     * Clears all results, generated from input by geocode
     * @returns {PropertyRouteMap}
     * @private
     */
    _clearAddressAid() {
        this.geocodeAid
            .empty()
            .removeClass('geocode-aid--filled')
            .addClass('geocode-aid--empty')
        return this
    }

    /**
     * Fills drop-down list with geocode results
     * @param geocodeResultsList
     * @returns {PropertyRouteMap}
     * @private
     */
    _fillAddressAid(geocodeResultsList) {
        this._clearAddressAid()
        var lis = geocodeResultsList.map((result, index) => {
            let current = index === 0 ? 'current' : ''
            return HTML('li')
                .classes(current)
                .append(
                    HTML('a')
                        .attr({ href: '#' })
                        .content(result.formatted_address)
                        .on('click', event => {
                            event.preventDefault()
                            this.geocodeInput.val(result.formatted_address)
                            this.setPosition(result.geometry.location)
                            this._clearAddressAid()
                        })
                        .render(),
                )
                .render()
        })

        this.geocodeAid.append(lis)
        this.geocodeAid.removeClass('geocode-aid--empty').addClass('geocode-aid--filled')
        this.geocodeAid.css({
            left: this.geocodeInput.offset().left - this.geocodeInput.parent().parent().offset().left + 'px',
        })
        return this
    }

    /**
     * Binds UI elements to actions
     * @returns {PropertyRouteMap}
     * @private
     */
    _bindUI() {
        function markElemInGroup(jQueryGroup, jQueryElem, className) {
            jQueryGroup.removeClass(className)
            jQueryElem.addClass(className)
        }

        this.geocodeInput.on('keyup', event => {
            var value = $(event.target).val()
            if (/ArrowUp|PageUp|ArrowDown|PageDown|Home|End|Enter/ig.test(event.originalEvent.key)) {
                return
            }
            if (value.length > 1) {
                this.geocodeFromAddress(value, (result, status) => {
                    if (result) {
                        this._fillAddressAid(result)
                    }
                })
            } else {
                this._clearAddressAid()
            }
        })
        this.geocodeInput.on('blur', event => {
            setTimeout(() => {
                this._clearAddressAid()
            }, 100)
        })
        this.geocodeInput.on('focus', event => {
            var value = $(event.target).val()
            if (value.length > 1) {
                this.geocodeFromAddress(value, (result, status) => {
                    if (result) {
                        this._fillAddressAid(result)
                    }
                })
            }
        })

        this.geocodeInput.on('keydown', event => {
            var gcOptions = this.geocodeAid.children(),
                current = gcOptions.filter('.current')
            if (gcOptions.length > 0) {
                switch (event.originalEvent.key) {
                    case 'ArrowUp':
                    case 'PageUp':
                        current.prev().length > 0
                        ? markElemInGroup(gcOptions, current.prev(), 'current')
                        : markElemInGroup(gcOptions, gcOptions.last(), 'current')
                        break
                    case 'ArrowDown':
                    case 'PageDown':
                        current.next().length > 0
                        ? markElemInGroup(gcOptions, current.next(), 'current')
                        : markElemInGroup(gcOptions, gcOptions.first(), 'current')
                        break
                    case 'Home':
                        markElemInGroup(gcOptions, gcOptions.first(), 'current')
                        break
                    case 'End':
                        markElemInGroup(gcOptions, gcOptions.last(), 'current')
                        break
                    case 'Enter':
                        current.find('a').get(0).dispatchEvent(new Event('click')) // sets origin position from geocode
                        this.buttons.buildRoute.trigger('click') // engages route constructor
                        break
                }
            }
        })

        this.buttons.buildRoute.on('click', event => {
            event.preventDefault()
            this.geocodeFromAddress(this.geocodeInput.val(), (result, status) => {
                if (result.length > 0) {
                    this.geocodeInput.val(result[0].formatted_address)
                    this.setPosition(result[0].geometry.location)
                }
            })
        })

        this.buttons.currentLocation.on('click', event => {
            event.preventDefault()
            this.executeGeolocation()
        })

        this.buttons.drivingTravelMode.on('click', event => {
            event.preventDefault()
            this.buttons.drivingTravelMode.addClass('active').siblings().filter('a').removeClass('active')
            this.setTravelMode('DRIVING')
        })
        this.buttons.walkingTravelMode.on('click', event => {
            event.preventDefault()
            this.buttons.walkingTravelMode.addClass('active').siblings().filter('a').removeClass('active')
            this.setTravelMode('WALKING')
        })
        this.buttons.bicyclingTravelMode.on('click', event => {
            event.preventDefault()
            this.buttons.bicyclingTravelMode.addClass('active').siblings().filter('a').removeClass('active')
            this.setTravelMode('BICYCLING')
        })

        this.buttons.directionDetailsToggler.on('click', event => {
            event.preventDefault()
            this.directionStepsRoot.toggleClass('show-contents')
            if (this.directionStepsRoot.hasClass('show-contents')) {
                markElemInGroup(
                    this.buttons.directionDetailsToggler.find('span'),
                    this.buttons.directionDetailsToggler.find('.hide-info'),
                    'active',
                )
                this.directionStepsRoot.height(this.directionStepsRoot.find('.adp').height())
            } else {
                markElemInGroup(
                    this.buttons.directionDetailsToggler.find('span'),
                    this.buttons.directionDetailsToggler.find('.show-info'),
                    'active',
                )
                this.directionStepsRoot.height(0)
            }
        })

        return this
    }

    renderCityMarkers() {
        var easy2map_id = this.root.data('property-easy2map-id');

        if (!easy2map_id) {
            return this;
        }

        Easy2MapMarkers.create(easy2map_id).request(markers => {
            markers.map(marker => {
                var infoWindow = new google.maps.InfoWindow({
                    content: HTML('div').append(
                        HTML('h4').content(marker.title).render(),
                        HTML('p').content(marker.htmlContent).render(),
                        HTML('a')
                            .content('Hitta närmaste väg')
                            .attr({
                                href: '#',
                                style: 'font-size: 1.4rem',
                            })
                            .on('click', event => {
                                event.preventDefault()
                                this.setPosition(marker.latLng)
                                this.geocodeFromLocation(marker.latLng, results => {
                                    if (results.length > 0) {
                                        this.geocodeInput.val(results[0].formatted_address)
                                    }
                                })
                            })
                            .render(),
                    ).render(),
                })

                var gmarker = new google.maps.Marker({
                    position: marker.latLng,
                    map: this.googleMap,
                    animation: google.maps.Animation.DROP,
                    icon: marker.icon,
                })

                gmarker.addListener('click', () => {
                    infoWindow.open(this.googleMap, gmarker)
                })
            })
        })

        return this
    }

    /**
     * Clears google map from DOM, allowing to completely redraw map
     * @returns {PropertyRouteMap}
     * @private
     */
    _clearMap() {
        this.mapRoot.empty()
        return this
    }

    /**
     * Prepares and renders all required Google Map elements
     * @returns {PropertyRouteMap}
     * @private
     */
    _createMap() {
        this.googleMap = new google.maps.Map(this.mapRoot.get(0), {
            styles: sharedData.googleMap.style,
            zoom: sharedData.googleMap.defaultZoomLevel,
            scrollwheel: false,
            draggable: false,
            center: this.originPosition,
        })

        // set current address to input & create link with directions to google map
        this.geocodeFromLocation(this.originPosition, results => {
            if (results && results.length > 0) {
                let address = results[0].formatted_address.split(', ')
                address.pop()
                this.addressInput.val(address.join(', '))
            }
        })

        this.buttons.buildDirections.on('click', () => {
            const destination = `${this.originPosition.lat},${this.originPosition.lng}`
            const origin = this.originInput.val()
            const url = `${this.googleDirectionsUrl}&origin=${encodeURIComponent(origin)}&destination=${destination}`
            window.open(url)
        })

        this.googleMap.addListener('click', data => {
            this.googleMap.setOptions({
                scrollwheel: true,
                draggable: true,
            })

            this.setPosition(data.latLng)
        })

        var content = this.propListView.projektCard(this.projekt)
        var clickButton = `<a class="projekt-more-info" href="${this.projekt.permalink}">Klicka för att läsa mer</a>`

        var projektCardInfoWindow = new google.maps.InfoWindow({
            content: content + clickButton,
        })

        var gmarker = new google.maps.Marker({
            position: this.position,
            map: this.googleMap,
            animation: google.maps.Animation.DROP,
            icon: sharedData.googleMap.projektIcon,
        })

        gmarker.addListener('click', () => {
            projektCardInfoWindow.open(this.googleMap, gmarker)
            imagesToSvg('.property-route-map img.replace-with-svg')
            infoWindowOpened = true
        })

        // Do not show prompt on hover when infoWindow is open
        var infoWindowOpened = false
        projektCardInfoWindow.addListener('closeclick', () => {
            infoWindowOpened = false
        })

        var clickMeWindow = new google.maps.InfoWindow({
            content: '<span class=\'gmap-click-prompt\'>Klicka för att läsa om projektet</span>',
        })

        google.maps.event.addListener(gmarker, 'mouseover', () => {
            if (!infoWindowOpened) {
                clickMeWindow.open(this.googleMap, gmarker)
            }
        })
        google.maps.event.addListener(gmarker, 'mouseout', () => {
            clickMeWindow.close()
        })

        this.mapRoot.prepend(
            HTML('div')
                .classes('abolute-fitter')
                .attr({
                    onclick: 'style.pointerEvents = \'none\'',
                    style: 'pointer-events: auto; z-index: 5;',
                })
                .render(),
        )
        return this
    }


    /**
     * Asynchronously initializes map and its dependencies
     */
    init() {
        $.ajax({
            url: ajaxurl,
            method: 'POST',
            data: {
                action: 'fetchSingleProjekt',
                projekt_wpid: this.projektWPID,
            },
            success: data => {
                if (data && typeof data !== 'undefined' && typeof data.projekt !== 'undefined') {
                    this.projekt = data.projekt

                    sharedData.googleMap.loadAssetsAsync(() => {
                        this._bindUI()
                        this.geocoder = new google.maps.Geocoder()
                        this._clearMap()._createMap().executeGeolocation()
                        this.renderCityMarkers()
                    })

                } else {
                    console.warn('AJAX handling error', data)
                }
            },
        })
    }
}


class Easy2MapMarkers {

    constructor(mapid) {
        this.mapid = mapid
        this.markers = []
    }

    /**
     * Create Easy2MapMarkers instance
     * @param {int} mapid
     * @returns {Easy2MapMarkers}
     */
    static create(mapid) {
        return new this(mapid)
    }

    /**
     * Do Async request for markers
     * @param {function} callback
     */
    request(callback) {
        $.ajax({
            url: ajaxurl,
            method: 'POST',
            data: {
                action: 'retrieve_map_points',
                MapID: this.mapid,
            },
            success: data => {
                if (data) {
                    this.markers = Easy2MapMarkers.normalize(JSON.parse(data))
                    if (typeof callback === 'function') {
                        callback(this.markers)
                    }
                } else {
                    console.warn('Easy2MapMarkers.request failure, received:', data)
                }
            },
        })
    }

    /**
     * Convert map markers data to more uniform format
     * @param {array} easy2MapMarkerArray
     * @returns {*}
     */
    static normalize(easy2MapMarkerArray) {
        var arr = easy2MapMarkerArray.map(marker => {
            try {
                var latLng = {
                    lat: Number.parseFloat(/\((\d+\.\d+),/i.exec(marker.LatLong)[1]),
                    lng: Number.parseFloat(/(\d+\.\d+)\)/i.exec(marker.LatLong)[1]),
                }
                return {
                    icon: marker.ImageURL,
                    latLng: latLng,
                    htmlContent: decodeURIComponent(marker.MapPinHTML),
                    title: marker.Title
                }
            } catch (e) {
                console.warn("Easy2MapMarkers.normalize failure", e);
                return false;
            }
        });

        return arr.filter(a => !!a);
    }
}

